export const campaign = {
  field: {
    id: 'ID',
    name: 'Judul',
    status: 'Status',
    skills: 'Mempertimbangkan keterampilan operator',
    type: 'Tipe',
    url: 'URL',
    time: 'min',
    weight: 'Berat kampanye',
    attempt: 'Mencoba',
    operators: 'Tambahkan operator',
    max_attempts: 'Upaya',
    attempts_interval_min: 'Waktu antara between attempts (menit)',
    max_time: 'Waktu tunggu maksimum (dtk.)',
    asr: 'ASR tetap',
    asr_default: 'ASR bawaan',
    resetAsr: 'Setel ulang otomatis ASR',
    avg_task: 'Durasi tugas rata-rata (dtk.)',
    dt_calls: 'DT Affecting calls',
    lost_calls: 'Periode perhitungan pentalan (menit)',
    percent_lost_calls: 'Persentase panggilan hilang',
    wait_operator: 'Operator tertunda (dtk.)',
    record: 'Rekam panggilan',
    sort: 'Menyortir tugas',
    direction: 'Arah',
    instance: 'Server',
    caller_id: 'Caller ID',
    pbx_number: 'Virtual PBX Number',
    calls_limit: 'Jumlah batasan calls',
    empty_data: 'Tidak ada data relevan yang tersedia',
    select_or_type: 'Pilih atau masukkan',
    machine_detection: {
      duration: 'Durasi (dtk.)',
      mode: 'Mode',
      on_threshold: 'Panggilan putus',
      threshold: 'Nilai ambang batas (%)'
    },
    welcome_message: 'Pesan selamat datang'
  },

  answering_machine: 'Mesin penjawab',

  select: {
    mode: {
      notification: 'Pemberitahuan',
      aggressive: 'Agresif'
    },
    type: {
      synchronous: 'Sinkronis',
      asynchronous: 'Asinkron'
    }
  },

  table: {
    action: {
      show_detail_stat: 'Lihat statistics',
      create: 'Tambah Kampanye'
    }
  },

  filter: {
    status: {
      title: '@:autocaller_v2.campaign.field.status',
      active: 'Aktiv',
      not_active: 'Tidak aktiv'
    },

    type: {
      title: '@:autocaller_v2.campaign.field.type',
      predictive: 'Prediktif',
      progressive: 'Progresif'
    },

    name: {
      title: '@:autocaller_v2.campaign.field.name'
    },

    pbx_number: {
      title: '@:autocaller_v2.campaign.field.pbx_number'
    },

    caller_id: {
      title: '@:autocaller_v2.campaign.field.caller_id'
    }
  },

  sort: {
    type: {
      priority: 'Prioritas',
      attempts: 'Upaya',
      lead_date: 'Tanggal pembuatan pesanan'
    },
    order: {
      asc: 'Naik',
      desc: 'Menurun'
    }
  },

  welcome_message: {
    success: 'Berkas media berhasil diunggah',
    modal_title: 'Pilih atau unggah file media'
  },
  tooltips: {
    welcome_message:
      'Anda dapat mengunggah file media yang akan didengar klien sebelum operator bergabung dengan panggilan.',
    welcome_message_with_instance:
      'Anda hanya dapat menggunakan file media untuk server tertentu.',
    welcome_message_with_select_instance:
      'Anda hanya dapat menggunakan file media untuk server tertentu. Pilih server.',
    weight:
      'Digunakan untuk menentukan urutan kampanye. Jika satu operator bekerja dengan beberapa kampanye, maka tugas kampanye dengan bobot tertinggi akan diproses terlebih dahulu.',
    avg_task:
      'Termasuk waktu untuk berbicara dengan klien dan waktu untuk bekerja dengan kartu klien.',
    dt_calls:
      'Jumlah panggilan, yang menjadi dasar penghitungan durasi panggilan dalam hitungan detik dari saat inisiasi hingga jawaban klien.',
      empty_data: 'Basis data kosong',
    need_support: 'Ekspor nomor dari database tidak tersedia saat ini. Harap hub',
    fix_asr:
      'Nilai ASR yang didefinisikan secara ketat yang tidak akan berubah selama seluruh kampanye. Pengaturan ASR lainnya diabaikan',
    wait_operator:
      'Nilai ambang batas untuk berapa lama klien menunggu respon operator. Diperkenalkan untuk pelanggan terpisah yang mencoba untuk menunggu respon dari pelanggan yang segera menjatuhkan panggilan.',
    sort:
      'Memungkinkan Anda untuk mengurutkan tugas-tugas kampanye dengan prioritas, urutan pembuatan tanggal, jumlah usaha. Mungkin untuk menunjukkan arah penyortiran. Menggunakan kursor, Anda dapat mengubah urutan dengan menambahkan, menyeret dan menjatuhkan kriteria pengurutan.',
    max_time: 'Waktu tunggu maksimal bagi klien untuk menjawab panggilan',
    sync_type:
      'Jenis sinkron. Klien pertama-tama akan terhubung ke AMD, dan hanya setelah menganalisis panggilan, koneksi ke operator akan terjadi.',
    async_type:
      'Jenis asinkron. Klien akan langsung terhubung ke operator, penentu AMD bekerja di latar belakang.',
    duration:
      'Tetapkan waktu yang dapat diterima untuk menentukan penjawab otomatis. Hasil paling akurat dicapai 7 detik setelah panggilan diproses oleh penentu mesin penjawab.',
    mode:
      'Modus pemberitahuan. AMD akan mencatat hasil pemrosesan panggilan dalam statistik, tetapi tidak akan membatalkan panggilan secara otomatis. Modus agresif. AMD akan mencatat hasil pemrosesan panggilan dalam statistik dan membatalkan panggilan ketika nilai ambang batas yang ditentukan tercapai.',
    threshold: 'Ketika nilai yang ditetapkan tercapai, panggilan akan terputus.',
    drop_call:
      'Pengaturan ini memungkinkan Anda untuk mengakhiri panggilan secara mandiri saat mesin penjawab terdeteksi.',
    hangup_cause_code: {
      1: 'Unallocated (unassigned) number',
      2: 'No route to specified transmit network',
      3: 'No route to destination',
      5: ' Misdialled trunk prefix (national use)',
      6: 'Channel unacceptable',
      7: ' Call awarded and being delivered in an established channel',
      8: 'Preemption',
      14: 'QoR: ported number',
      16: 'Normal Clearing',
      17: 'User busy',
      18: 'No user responding',
      19: 'No answer from user (user alerted)',
      20: 'Subscriber absent',
      21: 'Call Rejected',
      22: 'Number changed',
      23: 'Redirected to new destination',
      26: 'Non-selected user clearing',
      27: 'Destination out of order',
      28: 'Invalid number format',
      29: 'Facility rejected',
      30: 'Response to STATUS ENQUIRY',
      31: 'Normal, unspecified',
      34: 'No circuit/channel available',
      38: 'Network out of order',
      41: 'Temporary failure',
      42: 'Switching equipment congestion',
      43: 'Access information discarded',
      44: 'Requested circuit/channel not available',
      50: 'Requested facility not subscribed',
      52: 'Outgoing call barred',
      54: 'Incoming call barred',
      57: 'Bearer capability not authorized',
      58: 'Bearer capability not presently available',
      65: 'Bearer capability not implemented',
      66: 'Channel type not implemented',
      69: 'Requested facility not implemented',
      81: 'Invalid call reference value',
      88: 'Incompatible destination',
      95: 'Invalid message unspecified',
      96: 'Mandatory information element is missing',
      97: 'Message type non-existent or not implemented',
      98: 'Message not compatible with call state or message type non-existent or not implemented',
      99: 'Information element nonexistent or not implemented',
      100: 'Invalid information element contents',
      101: 'Message not compatible with call state',
      102: 'Recover on timer expiry',
      111: 'Protocol error, unspecified',
      127: 'Interworking, unspecified'
    },
    caller_id:
      'Anda perlu membeli nomor atau menambahkan nomor Anda sendiri. Untuk melakukan ini, buka bagian'
  },

  modal: {
    remove: {
      content: 'Saudara yakin akan menghapus campaign <b>{name}<b>?'
    },

    change_status: {
      enable: 'Saudara yakin ingin memulai pemanggil panggilan otomatis?',
      disable: 'Saudara yakin ingin memberhentikan pemanggil panggilan otomatis?'
    },

    notice_pbx_module_required: {
      content:
        'Membuat pemanggil prediktif campaigns, aktivasi "<strong>the virtual PBX service</strong>"',
      ok: 'Hubungkan'
    }
  },

  create: {
    title: '@:autocaller_v2.breadcrumb.campaign.new'
  },

  edit: {
    title: '@:autocaller_v2.breadcrumb.campaign.edit'
  },

  form: {
    title: 'Informasi dasar',
    parameters: 'Opsi Kampanye',
    settings: 'Pengaturan tambahan',
    determinant: 'Deteksi Mesin Penjawab',
    recipients_title: 'Penerima',
    save_btn: 'Simpan',
    update_btn: 'Perbaharui'
  }
};
